const showMobileMenu = () => {
    const hamburger = document.querySelector('.hamburger');
    const menu = document.querySelector('.header__main-bottom');

    hamburger.addEventListener('click', () => {
        menu.classList.toggle('header__main-bottom--active');
    })
}

const setNewsletterAcceptanceInputClass = () =>{
    const acceptanceLabel = document.querySelector('.newsletter__acceptance-label');
    if(acceptanceLabel){
        acceptanceLabel.addEventListener('click', () => {
            acceptanceLabel.classList.add('active')
        });
    }
}

const hideNotice = () => {
    const noticeContainer = document.querySelector('.notices');
    if(noticeContainer){
        noticeContainer.classList.add('notices__show');
        setTimeout(() => noticeContainer.classList.add('notices__hidden'), 7000);
    }
}

const toggleDefaultCheckboxClass = () => {
    const checkboxes = document.querySelectorAll('.form-checkbox__label');
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('click', (e) => {
            e.currentTarget.classList.toggle('form-checkbox__label--checked');
        });
    })
}

showMobileMenu();
setNewsletterAcceptanceInputClass();
hideNotice();
toggleDefaultCheckboxClass();
